import { IdToken } from '@auth0/auth0-react';
import Cookies from 'js-cookie';

export const SECURE_COOKIE_OPTIONS: Cookies.CookieAttributes = {
  secure: true,
  sameSite: 'strict',
  path: '/',
};

export class AuthTokenUtils {
  static set(authorization: string, idToken?: IdToken) {
    const { __raw, exp = 0 } = idToken || { __raw: '' };

    Cookies.set('authorization', authorization, {
      ...SECURE_COOKIE_OPTIONS,
      expires: exp * 1000,
    });

    Cookies.set('identity', __raw, {
      ...SECURE_COOKIE_OPTIONS,
      expires: exp * 1000,
    });
  }

  static clear() {
    Cookies.remove('identity', { path: '/' });
    Cookies.remove('authorization', { path: '/' });
  }

  static get() {
    return {
      authorization: Cookies.get('authorization'),
      identity: Cookies.get('identity'),
    };
  }
}
